import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_PAYER_DAY_COUNT_REQUEST,
  GET_PAYER_DAY_COUNT_SUCCESS,
  GET_PAYER_DAY_COUNT_FAILURE,
  GET_PAYER_DAY_COUNT_LOADING,
} = therapyPlanningAction;

function* getPayerDayCount(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PAYER_DAY_COUNT_LOADING });

    const response = yield call(therapyPlanningService.getPayerDayCount, payload.payload);
    if (response?.status === 200) {
      yield put({
        type: GET_PAYER_DAY_COUNT_SUCCESS,
        payload: response?.data,
      });
    } else throw response.data;
  } catch (error) {
    yield put({ type: GET_PAYER_DAY_COUNT_FAILURE, payload: error });
  }
}

function* getPayerDayCountSaga() {
  yield takeEvery(GET_PAYER_DAY_COUNT_REQUEST, getPayerDayCount);
}

export default getPayerDayCountSaga;
